/**
 * Has Non Empty Values Utility
 *
 * Utility function for checking if an object has any non-empty values
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

/**
 * Check if an object has any non-empty values
 */
export const hasNonEmptyValues = (
	obj: Record< string, unknown >,
): boolean => {
	return Object.values( obj ).some( ( value ) => {
		if ( value === null || value === undefined || value === '' )
			return false;
		if (
			typeof value === 'object' &&
			! Array.isArray( value ) &&
			value !== null
		) {
			return hasNonEmptyValues( value as Record< string, unknown > );
		}
		return true;
	} );
};
